import { defineMessages } from 'react-intl';

import { MFAErrorContext } from './types';

/**
 * The wrong-code message differs by screen, so it is selected from a mapping
 * rather than written inline where it is shown.
 */
export const wrongCodeMessages = defineMessages<MFAErrorContext>({
  verify: {
    id: 'mfa.error.wrongCodeOnVerify',
    defaultMessage:
      'Incorrect code. Codes change every 30 seconds — enter the current one from your authenticator app.',
  },
  setup: {
    id: 'mfa.error.wrongCodeOnSetup',
    defaultMessage:
      'Incorrect code. The key is saved but not confirmed yet — enter the current 6-digit code from the app.',
  },
  disable: {
    id: 'mfa.error.wrongCodeOnDisable',
    defaultMessage:
      'Incorrect code. Enter the current 6-digit code from your authenticator app.',
  },
});
